import { useState, useRef } from 'react';
import { BiReply, BiSend } from 'react-icons/bi';
import { useOnClickOutside } from 'usehooks-ts';
import { useAuthContext } from '../hooks/useAuthContext';
import { useMutation } from "@apollo/client";
import { ADD_REPLY } from '../mutations/replyMutations';
import EmojiPicker from './EmojiPicker';

export default function AddReplyButton({ commentId, postId, refetchPost }) {
  const [content, setContent] = useState('')
  const [replyMode, setReplyMode] = useState(false)
  const { authUser } = useAuthContext()

  const replyRef = useRef()

  const [addReply] = useMutation(ADD_REPLY, {
    variables: { content, postId, userId: authUser.id, commentId },
    onCompleted: () => {
      refetchPost()
    },
    onError: (error) => {
      throw new Error(error.message)
    }
  })

  const writeReply = () => {
    if (content === '') {
      return alert('Please fill up the content')
    }

    addReply()

    setReplyMode(false)
    setContent('')
  }

  const handleClickOutside = (e) => {
    if (replyRef.current && !replyRef.current.contains(e.target)) {
      e.stopPropagation()
      setReplyMode(false)
    }
  }
  
  useOnClickOutside(replyRef, handleClickOutside)
  
  return (
    <span ref={replyRef}>
      <BiReply className="icon rfs-3 cursor-pointer text-white" onClick={() => {
        setContent('')
        setReplyMode(!replyMode)
      }} />

      {replyMode &&
        <div className="d-flex mt-2 mb-1 container">
          <EmojiPicker content={content} setContent={setContent} />

          <input
            className="form-control me-1 rfs-6"
            placeholder="Add a reply..."
            id='content'
            value={content}
            autoFocus
            onChange={(e) => setContent(e.target.value)}
          />

          <BiSend className="my-auto cursor-pointer" onClick={writeReply} />
        </div>
      }
    </span>
  )
}
